// frontend/src/components/support/TipSelector.js
const TIPS = [0, 6, 8, 26, 28, 68];

export default function TipSelector({ selectedTip, setSelectedTip }) {
  return (
    <div
      style={{
        marginTop: 24,
      }}
    >
      <h3>Add Extra Support Tip</h3>

      <div
        style={{
          display: "flex",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        {TIPS.map((tip) => (
          <button
            key={tip}
            onClick={() => setSelectedTip(tip)}
            style={{
              padding: "12px 20px",

              borderRadius: 14,

              background:
                selectedTip === tip ? "#ffb100" : "rgba(255,255,255,0.08)",

              color: selectedTip === tip ? "#111" : "#fff",

              cursor: "pointer",
            }}
          >
            {tip === 0 ? "No Tip" : `$${tip}`}
          </button>
        ))}
      </div>
    </div>
  );
}
